import React from 'react';
import '../styles/JiboEye.css';

interface JiboEyeProps {
  size?: number;
  animated?: boolean;
}

const JiboEye: React.FC<JiboEyeProps> = ({ size = 120, animated = true }) => {
  return (
    <div
      className={`jibo-eye ${animated ? 'jibo-eye--animated' : ''}`}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <circle cx="60" cy="60" r="55" fill="#1a1a2e" stroke="#4a9eff" strokeWidth="2" />
        <ellipse
          className="jibo-eye__iris"
          cx="60"
          cy="60"
          rx="28"
          ry="28"
          fill="#4a9eff"
        />
        <ellipse
          className="jibo-eye__pupil"
          cx="60"
          cy="60"
          rx="14"
          ry="14"
          fill="#1a1a2e"
        />
        <ellipse
          className="jibo-eye__highlight"
          cx="50"
          cy="50"
          rx="6"
          ry="6"
          fill="rgba(255,255,255,0.6)"
        />
        <ellipse
          className="jibo-eye__highlight-small"
          cx="68"
          cy="68"
          rx="3"
          ry="3"
          fill="rgba(255,255,255,0.3)"
        />
      </svg>
    </div>
  );
};

export default JiboEye;
